export const featuredProperties = [
  {
    id: '1',
    title: 'Modern 3-Bedroom House in Hai Cinema',
    location: 'Hai Cinema',
    address: 'Plot 45, Cinema Road, Juba',
    price: 1200,
    currency: 'USD',
    bedrooms: 3,
    bathrooms: 2,
    parking: 2,
    area: 180,
    image: 'https://public.readdy.ai/ai/img_res/d0ac07f7e290e163e2befd017ad8c1f1.jpg',
    ribbon: 'FEATURED',
    type: 'rent',
    listingType: 'rent',
    description: 'Beautiful modern house with secure compound in Hai Cinema area',
    featured: true
  },
  {
    id: '2',
    title: 'Spacious Villa in Thongpiny',
    location: 'Thongpiny',
    address: 'Block C, Thongpiny Extension, Juba',
    price: 2500,
    currency: 'USD',
    bedrooms: 4,
    bathrooms: 3,
    parking: 3,
    area: 250,
    image: 'https://readdy.ai/api/search-image?query=Luxury%20villa%20in%20Juba%20South%20Sudan%20two%20story%20white%20painted%20walls%20with%20terracotta%20accents%20large%20windows%20balconies%20high%20security%20perimeter%20wall%20electric%20gate%20manicured%20lawn%20tropical%20garden%20mango%20trees%20afternoon%20sunlight%20contemporary%20African%20residential%20architecture%20professional%20photography&width=800&height=600&seq=thongpiny-luxury-villa-v2&orientation=landscape',
    ribbon: 'FEATURED',
    type: 'rent',
    listingType: 'rent',
    description: 'Luxurious villa with spacious compound and modern amenities',
    featured: true
  },
  {
    id: '3',
    title: 'Executive Apartment in Gudele',
    location: 'Gudele',
    address: 'Gudele Block 3, Near Gudele Market',
    price: 800,
    currency: 'USD',
    bedrooms: 2,
    bathrooms: 2,
    parking: 1,
    area: 120,
    image: 'https://readdy.ai/api/search-image?query=Modern%20apartment%20building%20in%20Gudele%20Juba%20South%20Sudan%20three%20stories%20beige%20concrete%20exterior%20metal%20balcony%20railings%20ground%20floor%20commercial%20shops%20paved%20parking%20area%20palm%20trees%20urban%20African%20architecture%20busy%20street%20professional%20real%20estate%20photography&width=800&height=600&seq=gudele-apartment-building-v2&orientation=landscape',
    ribbon: 'FEATURED',
    type: 'rent',
    listingType: 'rent',
    description: 'Modern apartment in prime Gudele location with excellent amenities',
    featured: true
  }
];

export const shortTermProperties = [
  {
    id: 'st-1',
    title: 'Luxury Serviced Apartment - Tongping',
    location: 'Tongping',
    address: 'Diplomatic Quarter, Tongping, Juba',
    price: 85,
    currency: 'USD',
    bedrooms: 2,
    bathrooms: 2,
    parking: 1,
    area: 95,
    image: 'https://readdy.ai/api/search-image?query=Elegant%20serviced%20apartment%20interior%20open%20plan%20living%20dining%20area%20cream%20colored%20sectional%20sofa%20wooden%20coffee%20table%20large%20windows%20with%20sheer%20curtains%20potted%20indoor%20plants%20modern%20African%20decor%20warm%20ambient%20lighting%20professional%20interior%20photography&width=800&height=600&seq=tongping-luxury-apt-unique-st001&orientation=landscape',
    ribbon: 'AIRBNB',
    type: 'short-term',
    listingType: 'short-term',
    description: 'Fully furnished luxury apartment with daily housekeeping, WiFi, and 24/7 security. Perfect for business travelers.',
    featured: true,
    priceUnit: 'night',
    minStay: 1,
    maxGuests: 4,
    amenities: ['WiFi', 'Air Conditioning', 'Kitchen', 'Washer', 'TV', 'Security']
  },
  {
    id: 'st-2',
    title: 'Cozy Studio Near UN Compound',
    location: 'Thongpiny',
    address: 'Near UNMISS Base, Thongpiny, Juba',
    price: 55,
    currency: 'USD',
    bedrooms: 1,
    bathrooms: 1,
    parking: 1,
    area: 45,
    image: 'https://readdy.ai/api/search-image?query=Compact%20modern%20studio%20apartment%20minimalist%20Scandinavian%20design%20single%20bed%20with%20white%20duvet%20small%20kitchenette%20stainless%20steel%20appliances%20floating%20desk%20by%20window%20natural%20wood%20flooring%20soft%20morning%20light%20professional%20real%20estate%20photography&width=800&height=600&seq=un-studio-compact-unique-st002&orientation=landscape',
    ribbon: 'SHORT STAY',
    type: 'short-term',
    listingType: 'short-term',
    description: 'Perfect studio for solo travelers or couples. Walking distance to UN compound with reliable power and water.',
    featured: true,
    priceUnit: 'night',
    minStay: 2,
    maxGuests: 2,
    amenities: ['WiFi', 'Air Conditioning', 'Kitchenette', 'TV', 'Generator']
  },
  {
    id: 'st-3',
    title: 'Family Villa with Pool - Weekly Rental',
    location: 'Hai Referendum',
    address: 'Referendum Estate, Block B, Juba',
    price: 450,
    currency: 'USD',
    bedrooms: 4,
    bathrooms: 3,
    parking: 3,
    area: 280,
    image: 'https://readdy.ai/api/search-image?query=Stunning%20family%20villa%20exterior%20view%20private%20infinity%20pool%20turquoise%20water%20surrounded%20by%20tropical%20garden%20palm%20trees%20outdoor%20wooden%20deck%20sun%20loungers%20white%20modern%20architecture%20blue%20sky%20sunny%20day%20professional%20architectural%20photography&width=800&height=600&seq=referendum-pool-villa-unique-st003&orientation=landscape',
    ribbon: 'WEEKLY',
    type: 'short-term',
    listingType: 'short-term',
    description: 'Spacious family villa with private pool, perfect for extended stays. Includes housekeeping and gardener.',
    featured: true,
    priceUnit: 'week',
    minStay: 7,
    maxGuests: 8,
    amenities: ['Pool', 'WiFi', 'Air Conditioning', 'Full Kitchen', 'Garden', 'Security', 'Housekeeping']
  },
  {
    id: 'st-4',
    title: 'Modern Loft in Juba Town Center',
    location: 'Juba Town Center',
    address: 'Central Business District, Juba',
    price: 70,
    currency: 'USD',
    bedrooms: 1,
    bathrooms: 1,
    parking: 0,
    area: 55,
    image: 'https://readdy.ai/api/search-image?query=Industrial%20style%20urban%20loft%20apartment%20exposed%20brick%20walls%20high%20vaulted%20ceiling%20large%20factory%20windows%20metal%20spiral%20staircase%20contemporary%20furniture%20leather%20armchair%20pendant%20Edison%20bulbs%20evening%20city%20lights%20professional%20interior%20photography&width=800&height=600&seq=cbd-loft-industrial-unique-st004&orientation=landscape',
    ribbon: 'AIRBNB',
    type: 'short-term',
    listingType: 'short-term',
    description: 'Trendy loft in the heart of Juba. Walk to restaurants, shops, and offices. Ideal for business travelers.',
    featured: false,
    priceUnit: 'night',
    minStay: 1,
    maxGuests: 2,
    amenities: ['WiFi', 'Air Conditioning', 'Kitchen', 'TV', 'Workspace']
  },
  {
    id: 'st-5',
    title: 'Guest House - Entire Property',
    location: 'Gudele',
    address: 'Gudele Phase 2, Juba',
    price: 120,
    currency: 'USD',
    bedrooms: 3,
    bathrooms: 2,
    parking: 2,
    area: 150,
    image: 'https://readdy.ai/api/search-image?query=Charming%20African%20guest%20house%20bungalow%20style%20terracotta%20exterior%20walls%20green%20metal%20roof%20wraparound%20covered%20porch%20rocking%20chairs%20flowering%20garden%20hibiscus%20bushes%20gravel%20driveway%20warm%20sunset%20glow%20professional%20real%20estate%20photography&width=800&height=600&seq=gudele-guesthouse-charming-unique-st005&orientation=landscape',
    ribbon: 'SHORT STAY',
    type: 'short-term',
    listingType: 'short-term',
    description: 'Entire guest house with private compound. Great for groups or families visiting Juba.',
    featured: false,
    priceUnit: 'night',
    minStay: 2,
    maxGuests: 6,
    amenities: ['WiFi', 'Air Conditioning', 'Full Kitchen', 'Garden', 'Parking', 'Security']
  }
];

export const allProperties = [
  ...featuredProperties,
  ...shortTermProperties,
  {
    id: '4',
    title: 'Luxury Mansion in Tongping',
    location: 'Tongping',
    address: 'Tongping Diplomatic Area, Juba',
    price: 4500,
    currency: 'USD',
    bedrooms: 5,
    bathrooms: 4,
    parking: 4,
    area: 400,
    image: 'https://readdy.ai/api/search-image?query=Diplomatic%20mansion%20in%20Tongping%20Juba%20South%20Sudan%20grand%20two%20story%20residence%20white%20exterior%20columns%20wide%20veranda%20swimming%20pool%20visible%20high%20concrete%20security%20wall%20electric%20gate%20landscaped%20gardens%20palm%20trees%20prestigious%20diplomatic%20quarter%20professional%20real%20estate%20photography&width=800&height=600&seq=tongping-diplomatic-mansion-v2&orientation=landscape',
    type: 'sale',
    listingType: 'sale',
    description: 'Stunning mansion in the prestigious Tongping diplomatic area',
    featured: false
  },
  {
    id: '5',
    title: 'Cozy 2-Bedroom in Munuki',
    location: 'Munuki',
    address: 'Munuki Residential, Near Munuki Payam',
    price: 650,
    currency: 'USD',
    bedrooms: 2,
    bathrooms: 1,
    parking: 1,
    area: 100,
    image: 'https://readdy.ai/api/search-image?query=Affordable%20family%20house%20in%20Munuki%20Juba%20South%20Sudan%20single%20story%20painted%20concrete%20walls%20green%20metal%20roof%20front%20porch%20compound%20fence%20fruit%20trees%20small%20garden%20typical%20African%20residential%20neighborhood%20warm%20sunlight%20authentic%20local%20architecture%20professional%20photography&width=800&height=600&seq=munuki-family-house-v2&orientation=landscape',
    type: 'rent',
    listingType: 'rent',
    description: 'Affordable and comfortable home in Munuki residential area',
    featured: false
  },
  {
    id: '6',
    title: 'Commercial Property in Juba Town',
    location: 'Juba Town Center',
    address: 'Juba Main Market Area',
    price: 3500,
    currency: 'USD',
    bedrooms: 0,
    bathrooms: 2,
    parking: 2,
    area: 200,
    image: 'https://readdy.ai/api/search-image?query=Commercial%20building%20in%20Juba%20town%20center%20South%20Sudan%20two%20story%20concrete%20structure%20shop%20fronts%20large%20windows%20business%20signage%20busy%20urban%20street%20pedestrians%20market%20stalls%20African%20city%20commercial%20district%20professional%20real%20estate%20photography%20daytime&width=800&height=600&seq=juba-commercial-property-v2&orientation=landscape',
    type: 'sale',
    listingType: 'sale',
    description: 'Prime commercial property in the heart of Juba',
    featured: false
  },
  {
    id: '7',
    title: 'Family Home in Hai Referendum',
    location: 'Hai Referendum',
    address: 'Referendum Block A, Juba',
    price: 1500,
    currency: 'USD',
    bedrooms: 4,
    bathrooms: 3,
    parking: 2,
    area: 220,
    image: 'https://readdy.ai/api/search-image?query=Spacious%20family%20home%20in%20Hai%20Referendum%20Juba%20South%20Sudan%20modern%20single%20story%20house%20cream%20painted%20walls%20large%20windows%20secure%20compound%20wall%20paved%20yard%20children%20play%20area%20mature%20trees%20tropical%20plants%20African%20residential%20architecture%20professional%20photography&width=800&height=600&seq=referendum-family-home-v2&orientation=landscape',
    type: 'rent',
    listingType: 'rent',
    description: 'Perfect family home with spacious rooms and secure compound',
    featured: false
  },
  {
    id: '8',
    title: 'Modern Studio in Kator',
    location: 'Kator',
    address: 'Kator Residential Area, Juba',
    price: 450,
    currency: 'USD',
    bedrooms: 1,
    bathrooms: 1,
    parking: 1,
    area: 60,
    image: 'https://readdy.ai/api/search-image?query=Modern%20apartment%20building%20in%20Kator%20Juba%20South%20Sudan%20three%20stories%20yellow%20painted%20concrete%20exterior%20metal%20balconies%20ground%20floor%20shops%20urban%20setting%20busy%20street%20young%20professional%20housing%20African%20city%20architecture%20professional%20real%20estate%20photography&width=800&height=600&seq=kator-modern-studio-v2&orientation=landscape',
    type: 'rent',
    listingType: 'rent',
    description: 'Compact and modern studio perfect for singles or couples',
    featured: false
  },
  {
    id: '9',
    title: 'Residential Land in Nyakuron',
    location: 'Nyakuron',
    address: 'Nyakuron Extension, Plot 120',
    price: 25000,
    currency: 'USD',
    bedrooms: 0,
    bathrooms: 0,
    parking: 0,
    area: 500,
    image: 'https://readdy.ai/api/search-image?query=Vacant%20residential%20land%20plot%20in%20Nyakuron%20Juba%20South%20Sudan%20cleared%20flat%20terrain%20boundary%20markers%20corner%20posts%20neighboring%20houses%20visible%20scattered%20trees%20African%20urban%20development%20area%20clear%20sky%20professional%20real%20estate%20photography&width=800&height=600&seq=nyakuron-land-plot-v2&orientation=landscape',
    type: 'sale',
    listingType: 'sale',
    description: 'Prime residential land ready for development',
    featured: false
  },
  {
    id: '10',
    title: 'Duplex in Hai Malakal',
    location: 'Hai Malakal',
    address: 'Malakal Street, Block 5, Juba',
    price: 1800,
    currency: 'USD',
    bedrooms: 3,
    bathrooms: 2,
    parking: 2,
    area: 180,
    image: 'https://readdy.ai/api/search-image?query=Two%20story%20duplex%20house%20in%20Hai%20Malakal%20Juba%20South%20Sudan%20modern%20design%20white%20and%20gray%20painted%20concrete%20walls%20metal%20balcony%20railing%20secure%20compound%20paved%20driveway%20tropical%20vegetation%20African%20residential%20architecture%20professional%20real%20estate%20photography&width=800&height=600&seq=malakal-duplex-house-v2&orientation=landscape',
    type: 'rent',
    listingType: 'rent',
    description: 'Spacious duplex with modern amenities in Hai Malakal',
    featured: false
  },
  {
    id: '11',
    title: 'Bungalow in Jebel Kujur',
    location: 'Jebel Kujur',
    address: 'Near Jebel Kujur Mountain, Juba',
    price: 1100,
    currency: 'USD',
    bedrooms: 3,
    bathrooms: 2,
    parking: 2,
    area: 150,
    image: 'https://readdy.ai/api/search-image?query=Single%20story%20bungalow%20house%20on%20hillside%20Jebel%20Kujur%20Juba%20South%20Sudan%20green%20painted%20concrete%20walls%20wide%20covered%20veranda%20mountain%20view%20background%20peaceful%20setting%20tropical%20garden%20trees%20African%20residential%20architecture%20professional%20real%20estate%20photography&width=800&height=600&seq=jebel-bungalow-hillside-v2&orientation=landscape',
    type: 'rent',
    listingType: 'rent',
    description: 'Peaceful bungalow with mountain views',
    featured: false
  },
  {
    id: '12',
    title: 'Townhouse in Hai Jalaba',
    location: 'Hai Jalaba',
    address: 'Jalaba Residential Complex, Juba',
    price: 2000,
    currency: 'USD',
    bedrooms: 4,
    bathrooms: 3,
    parking: 2,
    area: 200,
    image: 'https://readdy.ai/api/search-image?query=Modern%20townhouse%20in%20gated%20community%20Hai%20Jalaba%20Juba%20South%20Sudan%20row%20houses%20uniform%20design%20beige%20painted%20concrete%20shared%20green%20spaces%20security%20gate%20contemporary%20African%20residential%20complex%20professional%20real%20estate%20photography&width=800&height=600&seq=jalaba-townhouse-gated-v2&orientation=landscape',
    type: 'rent',
    listingType: 'rent',
    description: 'Modern townhouse in secure residential complex',
    featured: false
  }
];

export const locations = [
  'All Locations',
  'Hai Cinema',
  'Thongpiny',
  'Gudele',
  'Tongping',
  'Jebel Kujur',
  'Munuki',
  'Hai Referendum',
  'Hai Malakal',
  'Kator',
  'Nyakuron',
  'Hai Jalaba',
  'Juba Town Center',
];

export const propertyTypes = [
  { value: 'all', label: 'All Types' },
  { value: 'rent', label: 'For Rent' },
  { value: 'sale', label: 'For Sale' },
  { value: 'short-term', label: 'Short-Term / Airbnb' },
];

export const bedroomOptions = [
  { value: 'any', label: 'Any' },
  { value: '1', label: '1+' },
  { value: '2', label: '2+' },
  { value: '3', label: '3+' },
  { value: '4', label: '4+' },
  { value: '5', label: '5+' },
];

export const priceRanges = {
  rental: [
    { value: 'any', label: 'Any Price' },
    { value: '0-500', label: 'Under $500/mo' },
    { value: '500-1000', label: '$500 - $1,000/mo' },
    { value: '1000-2000', label: '$1,000 - $2,000/mo' },
    { value: '2000+', label: '$2,000+/mo' },
  ],
  sale: [
    { value: 'any', label: 'Any Price' },
    { value: '0-200000', label: 'Under $200K' },
    { value: '200000-350000', label: '$200K - $350K' },
    { value: '350000-500000', label: '$350K - $500K' },
    { value: '500000+', label: '$500K+' },
  ],
  shortTerm: [
    { value: 'any', label: 'Any Price' },
    { value: '0-50', label: 'Under $50/night' },
    { value: '50-100', label: '$50 - $100/night' },
    { value: '100-200', label: '$100 - $200/night' },
    { value: '200+', label: '$200+/night' },
  ],
};

export const sortOptions = [
  { value: 'newest', label: 'Newest First' },
  { value: 'price-low', label: 'Price: Low to High' },
  { value: 'price-high', label: 'Price: High to Low' },
  { value: 'beds-high', label: 'Bedrooms: Most' },
  { value: 'area-high', label: 'Area: Largest' },
];
